import isUndefinedOrNull from '../../TypeHelpers/isUndefinedOrNull';
import item from './item';
import where from './where';
export default function firstOrDefault(array, predicate, defaultValue = null) {
    var _a;
    if (!isUndefinedOrNull(predicate)) {
        array = where(array, predicate);
    }
    return (_a = item(array, 0)) !== null && _a !== void 0 ? _a : defaultValue;
}
